import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';


export default class Certificate {

    static listCertificates(data,additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'listCertificates',data, additionalHeaders);
    }

    static getAccountWCPolicyPeriodSummaries(authHeader={}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'getAccountWCPolicyPeriodSummaries',[],authHeader);
    }

    static getCertPolicyPeriod(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'getCertPolicyPeriod',data, authHeader);
    }

    static createCertificate(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'createCertificate',data, authHeader);
    }

    static getCertificate(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'getCertificate',data, authHeader);
    }

    static deleteCertificate(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'deleteCertificate',data, authHeader);
    }

    static generateCertificatePdf(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'generateCertificatePdf',data, authHeader);
    }

    static generateCertificatePdfZip(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'generateCertificatePdfZip',[data], authHeader);
    }

    static updateCertificate(data,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('certificate'), 'updateCertificate',data, authHeader);
    }

    
}
